import React, { useState } from 'react';
import { Link, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { deleteWikiPage } from 'api';
import { useWikiPage, MarkdownContent } from 'features/wiki';
import ConfirmDialog from 'components/ConfirmDialog';
import { formatDateTime } from 'utils/datetime';

const WikiPageViewPage = () => {
  const { pageId } = useParams();
  const { page, loading, error } = useWikiPage(pageId);
  const { refreshWikiPages } = useOutletContext();
  const navigate = useNavigate();
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  if (loading) {
    return (
      <div className="gh-box">
        <div className="gh-box-body d-flex align-items-center gap-2 text-muted-gh">
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
        <i className="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
        {error}
      </div>
    );
  }

  if (!page) {
    return null;
  }

  const handleDelete = async () => {
    await deleteWikiPage(page.id);
    await refreshWikiPages();
    navigate('/', { replace: true });
  };

  return (
    <div className="gh-box">
      <div className="gh-box-header d-flex align-items-center justify-content-between">
        <span>
          <i className="bi bi-file-earmark-text me-2" aria-hidden="true"></i>
          {page.title}
        </span>
        <div className="d-flex gap-2">
          <Link to={`/wiki/${page.id}/edit`} className="btn btn-sm btn-gh">
            <i className="bi bi-pencil me-1" aria-hidden="true"></i>
            Edit
          </Link>
          <button type="button" className="btn btn-sm btn-gh-danger" onClick={() => setConfirmingDelete(true)}>
            <i className="bi bi-trash me-1" aria-hidden="true"></i>
            Delete
          </button>
        </div>
      </div>
      <div className="gh-box-body">
        <div className="text-muted-gh mb-3 small">
          Last updated: {formatDateTime(page.updatedAt)}
          {page.lastUpdatedByUsername && ` by ${page.lastUpdatedByUsername}`}
        </div>
        <MarkdownContent content={page.content} />
      </div>

      {confirmingDelete && (
        <ConfirmDialog
          title="Delete page"
          message={<>Delete page <strong>{page.title}</strong>? This action cannot be undone.</>}
          confirmLabel="Delete"
          danger
          onConfirm={handleDelete}
          onCancel={() => setConfirmingDelete(false)}
        />
      )}
    </div>
  );
};

export default WikiPageViewPage;
